import { useDispatch, useSelector } from "react-redux";
import { downloadAntiLndReport } from "../thunks/downloadReport";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";

export const useAntiMnyLndCommReportDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.antiLaundering.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(() => dispatch(downloadAntiLndReport()), [
    dispatch,
  ]);

  return [download, fetchState] as [typeof download, typeof fetchState];
};
